import { useEffect, useState } from 'react';

import { ImagesApp } from '../../../../constants/images';
import { SafeLanguages } from '../../../../enums/safeLanguages';
import { useI18nContext } from '../../../../hooks/contexts/i18n.context';
import * as Style from './styles.localeSelect';

const SelectedLocale = () => {
  const [locale, setLocale] = useState(SafeLanguages.pt_br);
  const [countryAcronym, setCountryAcronym] = useState('PT' as string);
  const { currentLocale } = useI18nContext();

  useEffect(() => {

    const country = (currentLocale.locale ? Object.entries(currentLocale)[0][1] : navigator.language);
    const language = country.replace('-', '_').toLowerCase() as keyof typeof SafeLanguages;
    setLocale(SafeLanguages[language]);
    setCountryAcronym(country.split('_')[0].toUpperCase());

  }, [currentLocale]);

  return (
    <Style.StyledSelectedLocale id="selected-locale-container">
      <Style.StyledBadgeLocale
        id="badge-locale-selected"
        src={ImagesApp.countries[locale]} />
      <Style.StyledTextMenu id="text-menu-locale-selected">
        {countryAcronym.split('-')[0].toUpperCase()}
      </Style.StyledTextMenu>
    </Style.StyledSelectedLocale>
  );
};

export default SelectedLocale;
